/* eslint-disable max-len */
import React from 'react';

export default function ExchangeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
    >
      <g clipPath="url(#clip0_12804_7107)">
        <mask
          id="mask0_12804_7107"
          style={{ maskType: 'luminance' }}
          width="25"
          height="25"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
        >
          <path fill="#fff" d="M24.457.36h-24v24h24v-24z" />
        </mask>
        <g fill="#fff" mask="url(#mask0_12804_7107)">
          <path d="M22.957 4.336h-3.085a1 1 0 00-.707 1.707l1.085 1.086-3.585 3.585a1.024 1.024 0 01-1.415 0l-.17-.171a3.071 3.071 0 00-4.244 0l-5.1 5.1a1.003 1.003 0 101.421 1.417l5.1-5.1a1.023 1.023 0 011.415 0l.17.171a3.073 3.073 0 004.243 0l3.587-3.586 1.085 1.086a1 1 0 001.7-.709V5.836a1.5 1.5 0 00-1.5-1.5z" />
          <path d="M23.457 22.335h-18a3 3 0 01-3-3V1.36a1 1 0 00-2 0v17.976a5.006 5.006 0 005 5h18a1 1 0 000-2z" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_12804_7107">
          <path fill="#fff" d="M0 0H24V24H0z" transform="translate(.458 .36)" />
        </clipPath>
      </defs>
    </svg>
  );
}

ExchangeIcon.propTypes = {};
